// ----------------------------------------------------------------------

export interface RecordNavigation {
  /** 0-based position of the current id within the loaded set, or -1 when not present. */
  index: number;
  /** Previous id, or undefined at the start / when the current id is not in the set. */
  prevId?: string;
  /** Next id, or undefined at the end / when the current id is not in the set. */
  nextId?: string;
  /** 1-based position for the "Result N of M" indicator, hidden (undefined) on a cold deep-link. */
  position?: { index: number; total: number };
}

/**
 * Pure prev/next resolution for the record panel (JT1-1529). Walks the in-memory loaded ids and
 * clamps at both ends. When the current id is not in the loaded set — a cold deep-link before the
 * list's rows arrive — there is no navigation and no position indicator. `total` (all pages) drives
 * "Result N of <total>", falling back to the loaded length.
 */
export function resolveRecordNavigation(ids: string[], currentId: string | undefined, total?: number): RecordNavigation {
  const index = currentId ? ids.indexOf(currentId) : -1;

  if (index < 0) {
    return { index: -1 };
  }

  return {
    index,
    prevId: index > 0 ? ids[index - 1] : undefined,
    nextId: index < ids.length - 1 ? ids[index + 1] : undefined,
    position: { index: index + 1, total: total ?? ids.length },
  };
}
